<template>
  <exo-table :root="_self">
    <exo-form :root="_self">
      <v-row
        ><v-col> <exo-input-name :root="_self" /></v-col>
        <v-col>
          <exo-input-select :root="_self" name="type" />
        </v-col>
        <v-col
          ><exo-input-select
            :root="_self"
            name="criticity"
            :items="criticities"
        /></v-col>
      </v-row>
      <v-row>
        <v-col>
          <exo-input-double :root="_self" name="deltaVThresholdOnSma"
        /></v-col>
        <v-col
          ><exo-input-double :root="_self" name="deltaVThresholdOnInc"
        /></v-col>
      </v-row>
      <v-row>
        <exo-input-double :root="_self" name="smaTolerance" />
        <exo-input-double
          :root="_self"
          name="relativeInclinationTolerance"
        ></exo-input-double>
        <exo-input-checkbox
          :root="_self"
          name="computePastEvents"
        ></exo-input-checkbox>

        <exo-input-double :root="_self" name="threshold" />
        <exo-input-double :root="_self" name="nbOfOrbits" />
      </v-row>
      <v-row class="exo-checkbox">
        <exo-input-checkbox
          :root="_self"
          name="interestObjectsScope"
          trueValue="ALL"
          falseValue="USER_DEFINED"
          class="input-checkbox"
        ></exo-input-checkbox>
      </v-row>
      <v-row>
        <exo-input-ref-multiple
          :root="_self"
          name="primarySpaceObjectGroups"
          :isParametric="false"
          type="primarySpaceObjectGroups"
          componentRoute="/spaceobjectgroup"
          :notEmpty="true"
        ></exo-input-ref-multiple>
      </v-row>
      <v-row>
        <exo-input-checkbox
          :root="_self"
          name="opposedObjectsScope"
          trueValue="ALL"
          falseValue="USER_DEFINED"
          class="input-checkbox"
        ></exo-input-checkbox>
      </v-row>
      <v-row>
        <exo-input-ref-multiple
          :root="_self"
          name="secondarySpaceObjectGroups"
          :isParametric="false"
          type="secondarySpaceObjectGroups"
          componentRoute="/spaceobjectgroup"
          :notEmpty="true"
        ></exo-input-ref-multiple>
      </v-row>
    </exo-form>
  </exo-table>
</template>

<script>
import axios from '../../services/axios'
import defense from '../../mixins/defense.js'
import Vue from 'vue'
import VueAxios from 'vue-axios'
import errorMixin from '../../mixins/logHandler.js'
import formMixin from '../../mixins/forms.js'
import numericalMixin from '../../mixins/numericalForms.js'
import dataTools from '../../tools/data.js'
Vue.use(VueAxios, axios)
import fieldsDescription from '../../tools/fieldsDescription.json'

export default {
  name: 'AsbtractAlertDefinition',

  mixins: [errorMixin, formMixin, numericalMixin, defense],
  components: {},

  data() {
    return {
      tableFields: [
        {
          value: 'displayedName',
          text: this.getLabel('displayedName'),
          sortable: true
        },
        {
          value: 'type',
          text: this.getLabel('type'),
          sortable: true
        },
        {
          value: 'criticity',
          text: this.getLabel('criticity'),
          sortable: true
        },
        {
          value: 'primarySpaceObjectGroups',
          text: this.getLabel('primarySpaceObjectGroups')
        },
        { value: 'actions', text: 'Actions', sortable: false }
      ],

      context: 'AbstractAlertDefinition',
      enumPropertiesList: this.getEnumProperties(),
      inputs: {
        name: this.getDefaultValue('name'),
        type: this.getDefaultValue('type'),
        criticity: this.getDefaultValue('criticity'),
        threshold: this.getDefaultValue('threshold'),
        nbOfOrbits: this.getDefaultValue('nbOfOrbits'),
        smaTolerance: this.getDefaultValue('smaTolerance'),
        deltaVThresholdOnSma: this.getDefaultValue('deltaVThresholdOnSma'),
        deltaVThresholdOnInc: this.getDefaultValue('deltaVThresholdOnInc'),
        relativeInclinationTolerance: this.getDefaultValue(
          'relativeInclinationTolerance'
        ),
        computePastEvents: this.getDefaultValue('computePastEvents'),
        primarySpaceObjectGroups: [],
        secondarySpaceObjectGroups: [],
        interestObjectsScope: this.getDefaultValue('interestObjectsScope'),
        opposedObjectsScope: this.getDefaultValue('opposedObjectsScope')
      },

      primarySpaceObjectGroupssNotParametrics: [],
      secondarySpaceObjectGroupssNotParametrics: []
    }
  },
  watch: {
    'inputs.interestObjectsScope'() {
      this.inputs.primarySpaceObjectGroups = []
    },
    'inputs.opposedObjectsScope'() {
      this.inputs.secondarySpaceObjectGroups = []
    }
  },
  created() {},
  mounted() {
    this.refreshReferences()
  },
  computed: {
    criticities() {
      const low = {
        name: 'Information',
        color: 'green',
        defaultTooltip: 'Information',
        customTooltip: '',
        priority: 3
      }
      const medium = {
        name: 'Warning',
        color: 'orange',
        defaultTooltip: 'Warning',
        customTooltip: '',
        priority: 2
      }
      const high = {
        name: 'Critical',
        color: 'red',
        defaultTooltip: 'Critical',
        customTooltip: '',
        priority: 1
      }
      return Object.freeze(
        [low, medium, high].map((criticity) => {
          return { text: criticity.name, value: criticity }
        })
      )
    }
  },
  methods: {
    refreshReferences() {
      this.refreshSpaceObjectGroups()
    },
    refreshSpaceObjectGroups() {
      let self = this
      this.$http
        .get(this.getAPI('spaceobjectgroups'))
        .then((response) => {
          self.primarySpaceObjectGroupssNotParametrics = response.data
            .filter((obj) => !obj.displayedName.endsWith('*'))
            .map((obj) => ({ value: obj, text: obj.displayedName }))
            .sort((a, b) =>
              a.text.toLowerCase() < b.text.toLowerCase() ? -1 : 1
            )
          self.secondarySpaceObjectGroupssNotParametrics =
            self.primarySpaceObjectGroupssNotParametrics
        })
        .catch((e) => {
          self.displayMessage(
            'Error getting list of space object group. ',
            e,
            'NumericalMissionErrorDisplay',
            'error'
          )
        })
    },

    getCurrentFormType() {
      return 'AbstractAlertDefinition'
    },
    getSubTypes(instance) {
      let types = {
        type: instance.type,
        interestObjectsScope: instance.interestObjectsScope
      }
      if (instance.type !== 'MANEUVER') {
        types.opposedObjectsScope = instance.opposedObjectsScope
      }
      return types
    },

    getOptionalPropertiesList(instance) {
      let subTypes = this.getSubTypes(instance)
      let objectType = this.getCurrentFormType()
      return dataTools.getPropertiesList(
        fieldsDescription[objectType],
        subTypes,
        'optional'
      )
    },

    getRequiredPropertiesList(instance) {
      let subTypes = this.getSubTypes(instance)
      let objectType = this.getCurrentFormType()
      let requiredList = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        subTypes,
        'required'
      )
      return requiredList
    },
    getRefList(param) {
      if (param === 'primarySpaceObjectGroups') {
        return this.primarySpaceObjectGroupssNotParametrics
      }
      if (param === 'secondarySpaceObjectGroups') {
        return this.secondarySpaceObjectGroupssNotParametrics
      }
    },
    getAllPropertiesUnionList() {
      let objectType = this.getCurrentFormType()
      let requiredList = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        null,
        'required'
      )
      let optionalList = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        null,
        'optional'
      )
      return [...new Set(requiredList.concat(optionalList))]
    },

    getFieldState(parentObject, fieldName) {
      let fieldState = numericalMixin.methods.getFieldState.call(
        this,
        parentObject,
        fieldName,
        true
      )
      if (
        parentObject[fieldName] == null ||
        ((fieldName === 'primarySpaceObjectGroups' ||
          fieldName === 'secondarySpaceObjectGroups') &&
          parentObject[fieldName].length === 0)
      ) {
        fieldState.value = false
        fieldState.message = 'You must at least select one group.'
      }
      if (fieldState.message === '') {
        fieldState.message = true
      }
      return fieldState
    },
    clearForm() {
      this.inputs.name = this.getDefaultValue('name')
      this.inputs.type = this.getDefaultValue('type')
      this.inputs.criticity = this.getDefaultValue('criticity')
      this.inputs.threshold = this.getDefaultValue('threshold')
      this.inputs.nbOfOrbits = this.getDefaultValue('nbOfOrbits')
      this.inputs.smaTolerance = this.getDefaultValue('smaTolerance')
      this.inputs.deltaVThresholdOnSma = this.getDefaultValue(
        'deltaVThresholdOnSma'
      )
      this.inputs.deltaVThresholdOnInc = this.getDefaultValue(
        'deltaVThresholdOnInc'
      )
      this.inputs.relativeInclinationTolerance = this.getDefaultValue(
        'relativeInclinationTolerance'
      )
      this.inputs.primarySpaceObjectGroups = []
      this.inputs.secondarySpaceObjectGroups = []
    },
    getCustomFields() {
      return ['criticity', 'primarySpaceObjectGroups']
    },
    displayCustomValue(item, header) {
      if (header === 'criticity') {
        return item.criticity.name
      }
      if (header === 'primarySpaceObjectGroups') {
        if (item.primarySpaceObjectGroups) {
          if (item.primarySpaceObjectGroups.length == 0) {
            return 'Global group'
          } else {
            const listSpaceObjectGroup = item.primarySpaceObjectGroups
              .map((spaceObjectGroup) => {
                if (spaceObjectGroup == null) {
                  return ''
                } else {
                  return spaceObjectGroup.name
                }
              })
              .join(', ')
            if (listSpaceObjectGroup === '') {
              return 'All groups have been deleted'
            } else {
              return listSpaceObjectGroup
            }
          }
        } else {
          return null
        }
      }
    },
    getCustomInfos() {},
    getValueFields() {
      return []
    },
    isExoInputMultiple(item) {
      return (
        item === 'primarySpaceObjectGroups' ||
        item === 'secondarySpaceObjectGroups'
      )
    }
  }
}
</script>

<style scoped>
.exo-checkbox {
  width: 30%;
}
</style>
